import { EditOutlined } from '@ant-design/icons';
import { Button, Card, message, Spin, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { errorHandler, ordenarVigencias } from '../../utils';
import { instanceRef } from '../../utils/axios';
import VigenciaConfigForm from './componentes/VigenciaConfigForm';

const AseguradoraEmpresaProductoVigencia = () => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [model, setModel] = useState();
  const [formDisable, setFormDisable] = useState(false);
  const [vigencias, setVigencias] = useState();
  const [vigenciaHabilitadaIdList, setVigenciaHabilitadaIdList] = useState([]);
  const [modalidadHabilitadaIdList, setModalidadHabilitadaIdList] = useState(
    []
  );

  const {
    params: { id }
  } = useRouteMatch();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      setFormDisable(true);
      await instanceRef.instance.post(
        `aseguradoraempresaproducto/vigencia/${id}`,
        values
      );
      loadModel();
      setLoading(false);
      message.success('Actualizado correctamente');
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const loadModel = async () => {
    try {
      setLoading(true);

      const response = await instanceRef.instance.get(
        `aseguradoraempresaproducto/vigenciaconfig/${id}`
      );
      const data = response.data?.data;
      if (data) {
        const { aseguradoraEmpresaProducto, aseguradoraProducto } = { ...data };
        const {
          id_producto,
          producto,
          aseguradora,
          aseguradoraEmpresa,
          agendamiento_max_vigencia_cantidad,
          agendamiento_max_vigencia_unidad,
          empresaProductoVigencia,
          calculo_costo_parametros,
          premio_minimo_poliza_gs,
          premio_minimo_poliza_usd,
          promocion_contado,
          recargo_periodo_corto,
          tasa_descuento_pago_total_multianual,
          cantidad_pagos_sugerida,
          cobertura_max_cantidad,
          cobertura_max_unidad,
          cobertura_min_cantidad,
          cobertura_min_unidad,
          emision_multiperiodo,
          retroactividad_cantidad,
          retroactividad_unidad,
          tasa_interes,
          empresaProductoModalidad
          // aseguradoraProductoVigencia
        } = { ...aseguradoraEmpresaProducto };

        let formData = {
          id,
          id_producto,
          producto,
          aseguradora,
          aseguradoraEmpresa,
          agendamiento_max_vigencia_cantidad,
          agendamiento_max_vigencia_unidad,
          empresaProductoVigencia,
          calculo_costo_parametros,
          premio_minimo_poliza_gs,
          premio_minimo_poliza_usd,
          promocion_contado,
          recargo_periodo_corto,
          tasa_descuento_pago_total_multianual,
          cantidad_pagos_sugerida,
          cobertura_max_cantidad,
          cobertura_max_unidad,
          cobertura_min_cantidad,
          cobertura_min_unidad,
          emision_multiperiodo,
          retroactividad_cantidad,
          retroactividad_unidad,
          tasa_interes,
          empresaProductoModalidad,
          aseguradoraProductoVigencia:
            aseguradoraProducto.aseguradoraProductoVigencia,
          aseguradoraProductoModalidad:
            aseguradoraProducto.aseguradoraProductoModalidad
        };
        if (!data.aseguradoraEmpresaProducto.calculo_costo_parametros) {
          formData = {
            ...formData,
            calculo_costo_parametros: {
              premio_minimo_poliza_gs: null,
              premio_minimo_poliza_usd: null,
              promocion_contado: null,
              tasa_descuento_pago_total_multianual: null
            }
          };
        }
        setModel(formData);
        if (formData.cobertura_max_cantidad) {
          setFormDisable(true);
        }
        setTitle(formData.producto.descripcion);

        let vigenciaList = [];
        if (aseguradoraProducto) {
          vigenciaList = aseguradoraProducto.aseguradoraProductoVigencia.filter(
            (item) => item.habilitado === true
          );
        }
        setVigencias(
          ordenarVigencias(vigenciaList.map((item) => item.vigenciaPago))
        );
      }

      setLoading(false);
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (model) {
      setVigenciaHabilitadaIdList(
        model.empresaProductoVigencia
          ? model.empresaProductoVigencia
              .filter((item) => item.habilitado)
              .map((item) => item.id_vigencia_pago)
          : []
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [model]);

  useEffect(() => {
    loadModel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ResponsiveContainer size="large">
      <Card
        title={`Configuración de Vigencia - ${title}`}
        style={{ textAlign: 'left' }}
        extra={
          <Tooltip title="Editar">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => setFormDisable(false)}
              disabled={!formDisable}
            />
          </Tooltip>
        }
      >
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <div>
            {model && vigencias && (
              <VigenciaConfigForm
                model={model}
                onFinish={onFinish}
                disabled={formDisable}
                esEmpresa
                {...{
                  vigencias,
                  vigenciaHabilitadaIdList,
                  setVigenciaHabilitadaIdList,
                  modalidadHabilitadaIdList,
                  setModalidadHabilitadaIdList
                }}
              />
            )}
          </div>
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
};

export default AseguradoraEmpresaProductoVigencia;
